/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import axios from 'axios'
import apiConnect from '../../../api/apiConnect'
import {Link} from 'react-router-dom'
import {useParams} from 'react-router-dom'
import {useThemeMode} from '../../../../_metronic/partials'
import {ParameterWidget} from './component/ParameterWidget'
import clsx from 'clsx'
import {ParameterTableView} from './component/ParameterTableView'

const RealtimeDataTab = ({deviceData, isMobile}) => {
  const deviceId = useParams().deviceId
  const [trigger, setTrigger] = useState(true)
  const [parameterLists, setParameterLists] = useState([])
  const [digitalOutputLists, setDigitalOutputLists] = useState([])
  const [settingParameterLists, setSettingParameterLists] = useState([])
  const [statusParameterLists, setStatusParameterLists] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [lastUpdatedTime, setLastUpdatedTime] = useState(new Date())
  const {mode} = useThemeMode()

  const [limitParameter, setLimitParameter] = useState(60)

  const [activeView, setActiveView] = useState(() => {
    return localStorage.getItem('activeView') || 'table'
  })

  const handleToggle = (view) => {
    setActiveView(view)
    localStorage.setItem('activeView', view)
  }

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/devices/by-device-id/${deviceId}`)
        setLimitParameter(response.data?.limitParameter ? response.data?.limitParameter : 60)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [trigger])

  useEffect(() => {
    const interval = setInterval(() => {
      setTrigger((prev) => !prev)
      setLastUpdatedTime(new Date())
    }, 60000) // 60 วินาที

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/parameters/by-device-id/${deviceId}`)
        setParameterLists(response.data.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    if (deviceId !== undefined) {
      fetchData()
    }
  }, [trigger, deviceData])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/digital-outputs/by-device-id/${deviceId}`)
        setDigitalOutputLists(response.data.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    if (deviceId !== undefined) {
      fetchData()
    }
  }, [trigger, deviceData])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/setting-parameters/by-device-id/${deviceId}`)
        setSettingParameterLists(response.data.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    if (deviceId !== undefined) {
      fetchData()
    }
  }, [trigger, deviceData])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/status-parameters/by-device-id/${deviceId}`)
        setStatusParameterLists(response.data.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    if (deviceId !== undefined) {
      fetchData()
    }
  }, [trigger, deviceData])

  const columns = isMobile
    ? [
        {
          name: 'Name',
          selector: (row) => row.name,
          sortable: true,
          cell: (row) => (
            <div className='d-flex align-items-center'>
              <div className='symbol symbol-30px me-2'>
                <img src={row.icon} alt='' />
              </div>
              <Link to={`/device/${deviceId}/parameter/${row.id}`}>
                <p className='mb-0'>{row.name}</p>
              </Link>
            </div>
          ),
        },
        {
          name: 'Value',
          selector: (row) => row.current_value,
          sortable: true,
          cell: (row) => (
            <p className='mb-0'>
              {row.type === 'status_parameter'
                ? row.current_log.message
                : row.type === 'digital_output'
                ? row.current_value
                : Math.round(row.current_value * 100) / 100}
            </p>
          ),
        },
        {
          name: 'Last Update',
          selector: (row) => row.current_time,
          sortable: true,
          cell: (row) => {
            return (
              <p>
                {row.type == 'status_parameter'
                  ? getTimeFormat(row.current_log.timestamp)
                  : getTimeFormat(row.current_time)}
              </p>
            )
          },
        },
      ]
    : [
        {
          name: 'Status',
          selector: (row) => row.current_status,
          sortable: true,
          width: '100px',
          cell: (row) => {
            return (
              <p>
                {row.type == 'status_parameter' ? (
                  row.current_log.status == 'normal' ? (
                    <span className='badge badge-success badge-circle w-10px h-10px me-1'></span>
                  ) : row.current_log.status == 'abnormal' ? (
                    <span className='badge badge-danger badge-circle w-10px h-10px me-1'></span>
                  ) : row.current_log.status == 'offline' ? (
                    <span className='badge badge-dark badge-circle w-10px h-10px me-1'></span>
                  ) : (
                    <span className='badge badge-light-dark'>{row.current_log.status}</span>
                  )
                ) : row.current_status == 'normal' ? (
                  <span className='badge badge-success badge-circle w-10px h-10px me-1'></span>
                ) : row.current_status == 'abnormal' ? (
                  <span className='badge badge-danger badge-circle w-10px h-10px me-1'></span>
                ) : row.current_status == 'offline' ? (
                  <span className='badge badge-dark badge-circle w-10px h-10px me-1'></span>
                ) : (
                  <span className='badge badge-light-dark'>{row.current_status}</span>
                )}
              </p>
            )
          },
        },
        {
          name: 'Name',
          selector: (row) => row.name,
          sortable: true,
          cell: (row) => {
            return (
              <>
                <div className='symbol symbol-30px me-2'>
                  <img src={row.icon} alt='' />
                </div>
                <Link to={`/device/${deviceId}/parameter/${row.id}`}>
                  <p>{row.name}</p>
                </Link>
              </>
            )
          },
        },

        {
          name: 'Last Update',
          selector: (row) => row.current_time,
          sortable: true,
          cell: (row) => {
            return (
              <p>
                {row.type == 'status_parameter'
                  ? getTimeFormat(row.current_log.timestamp)
                  : getTimeFormat(row.current_time)}
              </p>
            )
          },
        },
        {
          name: 'Value',
          selector: (row) => row.current_value,
          sortable: true,
          cell: (row) => {
            return (
              <p>
                {row.type == 'status_parameter' ? (
                  <p>{row.current_log.message}</p>
                ) : row.type == 'digital_output' ? (
                  <p>{row.current_value}</p>
                ) : (
                  <p className='fw-semibold fs-5 mt-5'>
                    {Math.round(row.current_value * 100) / 100}
                  </p>
                )}
              </p>
            )
          },
        },
        {
          name: 'Min/Max',
          selector: (row) => row.type,
          sortable: true,
          cell: (row) => {
            return (
              <p>
                {row.type == 'status_parameter' ? (
                  <p>-</p>
                ) : (
                  <p>
                    {row.min} / {row.max}
                  </p>
                )}
              </p>
            )
          },
        },
      ]

  const combinedArray = parameterLists.concat(
    digitalOutputLists,
    settingParameterLists,
    statusParameterLists
  )

  // เพิ่มการกรองข้อมูลบน DataTable ก่อนแสดงผล
  const filteredData = combinedArray.filter(
    (parameter) =>
      parameter.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      parameter.id.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <>
      <div className='card mb-5 mb-xl-5'>
        <div className='card-header border-0 pt-2 d-flex justify-content-between align-items-center mb-3'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Parameter ({filteredData.length})</span>
          </h3>

          <div className='d-flex flex-column flex-md-row gap-3 w-100 w-md-auto'>
            <div className='btn-group w-100 w-md-auto' role='group'>
              <button
                type='button'
                className={clsx('btn btn-sm w-100 w-md-auto', {
                  'btn-primary text-white': activeView === 'table',
                  'btn-secondary': activeView !== 'table',
                })}
                onClick={() => handleToggle('table')}
              >
                <i className='bi bi-table'></i> Table
              </button>
              <button
                type='button'
                className={clsx('btn btn-sm w-100 w-md-auto', {
                  'btn-primary text-white': activeView === 'card',
                  'btn-secondary': activeView !== 'card',
                })}
                onClick={() => handleToggle('card')}
              >
                <i className='bi bi-grid'></i> Card
              </button>
            </div>

            {filteredData.length < limitParameter && (
              <Link to={`/create-new-parameter/${deviceId}`} className='w-100 w-md-auto'>
                <div className='btn btn-sm btn-primary w-100 w-md-auto'>Create new parameter</div>
              </Link>
            )}
          </div>
        </div>
      </div>

      {activeView === 'card' && (
        <>
          <div className='card mb-5 mb-xl-5'>
            <div className='card-header border-0 pt-2 d-flex justify-content-between align-items-center'>
              <div className='mt-5'>
                <span className='badge badge-success badge-circle w-10px h-10px mt-1 me-3'></span>
                <span className='text-gray-600 me-2'>
                  Last Update: {getTimeFormat(lastUpdatedTime.getTime() / 1000)}
                </span>
              </div>

              <div className='input-group w-lg-auto mt-3 mb-3'>
                <span className='input-group-text'>
                  <i className='fas fa-search'></i>
                </span>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Search...'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className='card-body py-3 mb-5'>
              <div className='row g-5'>
                {filteredData.map((parameter) => {
                  return (
                    <div className='col-xl-4 col-lg-6 col-md-6 col-12' key={parameter?.id}>
                      <ParameterWidget
                        className='card-xl-stretch mb-xl-8  h-100'
                        avatar={parameter?.icon_url}
                        title={parameter?.name}
                        value={parameter?.current_log?.v}
                        unit={parameter?.unit}
                        timestamp={
                          parameter?.type == 'status_parameter'
                            ? getTimeFormat(parameter?.current_log?.timestamp)
                            : getTimeFormat(parameter?.current_time)
                        }
                        status={parameter?.current_log?.s}
                        deviceId={deviceId}
                        parameterId={parameter?.id}
                      />
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </>
      )}

      {activeView === 'table' && <ParameterTableView />}
    </>
  )
}

export {RealtimeDataTab}

function getTimeFormat(timestamp) {
  const createdAt = new Date(timestamp * 1000)
  const formattedDate = createdAt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const formattedTime = createdAt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  return formattedDateTime
}
